/**
 * Determines whether attendee fields (name & email) should be locked in Cal.com embed
 * based on the program type.
 *
 * Rules:
 * - Fertility programs: Allow edits (user might book for partner)
 * - All other programs (menopause, postpartum, pregnancy): Lock fields (user books for self)
 *
 * @param programSlug - The program slug (e.g., 'fertility-consultation', 'pregnancy-ask-a-midwife')
 * @returns true if fields should be locked (readonly), false if editable
 */
export function shouldLockAttendeeFields(programSlug?: string): boolean {
  return !programSlug?.toLowerCase().includes('fertility')
}
